import type { Meta, StoryObj } from "@storybook/react";

import type { OnboardingOverviewCardProps } from "@/ui/components/onboarding/v2/cards/OnboardingOverviewCard";
import { OnboardingOverviewCard } from "@/ui/components/onboarding/v2/cards/OnboardingOverviewCard";

const StoryMeta: Meta<OnboardingOverviewCardProps> = {
  title: "Components/Onboarding/Cards/Onboarding Overview Card",
  component: OnboardingOverviewCard,
  args: {
    currentStepIndex: 0,
    currentStepLabel: "Your profile",
  },
  argTypes: {
    currentStepIndex: {
      control: "number",
    },
    currentStepLabel: {
      control: "text",
    },
    onContinuePress: {
      action: "onContinuePress",
    },
    patientName: {
      control: "text",
    },
  },
};

type Story = StoryObj<OnboardingOverviewCardProps>;

const Primary: Story = {};

const InProgress: Story = {
  args: {
    currentStepIndex: 2,
    currentStepLabel: "What treatment looks like",
  },
};

const ProxyView: Story = {
  args: {
    currentStepIndex: 1,
    currentStepLabel: "Renee's clinical picture",
    patientName: "Renee",
  },
};

export { InProgress, Primary, ProxyView };
export default StoryMeta;
